// extracted by mini-css-extract-plugin
module.exports = {"search_btn":"Search_search_btn__3KbKS"};